<template>
  <div :class="`sideMain ${isSidebarOpened ? 'opened' : ''}`">
    <div class="workspaceInfo">
      <div class="workspaceInfo__top">
        <div class="workspaceInfo__header">
          <span class="workspaceInfo__title textOverflow hideOnClose">
            Consultório
          </span>
          <button class="sideMain__toggle" @click="toggleSidebar">
            <ArrowLeft />
          </button>
        </div>
        <div class="workspaceInfo__name hideOnClose">
          <v-clamp
            :max-lines="2"
            class="workspaceInfo__name--text"
            :title="currWorkspace.clinic.beautifiedName"
          >
            {{ currWorkspace.clinic.beautifiedName }}
          </v-clamp>
        </div>
      </div>
      <div class="workspaceInfo__bottom">
        <Button secondary class="configApp" :to="configLink">
          <SettingsIcon class="configApp__icon" />
          <strong class="textOverflow hideOnClose"> Configurações </strong>
        </Button>
      </div>
    </div>
    <Divider class="sideBarDivider" />
    <div class="quickActions">
      <div class="quickActions__title textOverflow hideOnClose">
        Ações rápidas
      </div>
      <div class="quickActions__list">
        <QuickActionItem
          v-for="(action, index) in quickActions"
          :key="index"
          :icon="action.icon"
          :label="action.label"
          :hideLabel="!isSidebarOpened"
          @click="action.handler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import Divider from '@/components/Divider';
import QuickActionItem from './QuickActionItem';
import ArrowLeft from '@/assets/arrow-small-left.svg';
import SettingsIcon from '@/assets/icon-settings.svg';
import VClamp from 'vue-clamp';
import Button from '@/components/Button';

export default {
  name: 'SideMain',
  components: {
    ArrowLeft,
    QuickActionItem,
    VClamp,
    Divider,
    SettingsIcon,
    Button,
  },

  data() {
    return {
      quickActions: [
        {
          icon: require('@/assets/plus.svg'),
          label: 'Marcar consulta',
          handler: () => this.toggleModal('newMedicalMeeting'),
        },
        {
          icon: require('@/assets/add-patient.svg'),
          label: 'Adicionar paciente',
          handler: () => this.toggleModal('newPatient'),
        },
      ],
    };
  },

  computed: {
    ...mapState('dashboard', ['isSidebarOpened', 'showModals']),
    ...mapState('auth', ['hasMultilogin']),
    ...mapGetters('dashboard', ['currWorkspace']),
    configLink() {
      const { token } = this.currWorkspace,
        { hasMultilogin: multilogin } = this;

      return {
        name: 'config',
        query: {
          token,
          multilogin,
        },
      };
    },
  },

  methods: {
    ...mapActions('dashboard', ['toggleSidebar', 'toggleModal']),
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
